import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface Tab {
  key: string;
  label: string;
  icon?: LucideIcon;
  count?: number;
}

interface TabSwitcherProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (key: string) => void;
  size?: 'sm' | 'md';
  className?: string;
}

const TabSwitcher: React.FC<TabSwitcherProps> = ({
  tabs,
  activeTab,
  onChange,
  size = 'md',
  className = '',
}) => {
  const isSmall = size === 'sm';

  return (
    <div className={`flex bg-pt-cream rounded-[24px] p-1.5 ${className}`}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;
        const TabIcon = tab.icon;
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            className={`${isSmall ? 'px-3 py-2.5 rounded-xl text-[9px]' : 'px-6 py-3 rounded-[20px] text-[10px]'} font-black uppercase tracking-widest transition-all flex items-center gap-1.5 ${
              isActive
                ? 'bg-pt-forest text-pt-gold shadow-lg'
                : 'text-pt-sage-text hover:text-pt-forest'
            }`}
          >
            {TabIcon && <TabIcon size={isSmall ? 12 : 14} />}
            {tab.label}
            {tab.count != null && (
              <span className={`ml-1 ${isActive ? 'text-pt-gold/60' : 'text-pt-sage-text/50'}`}>
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default React.memo(TabSwitcher);
